import ApiService from '@/services/ApiService'
let api = new ApiService()

export default {
    async getCategories () {
        let result = await api.get('public/categories')
        return result
    },

    async getItemsForCategory (categoryID) {
        let result = await api.get('public/categories/' + categoryID)
        return result
    }
}



// WEBPACK FOOTER //
// ./src/services/CategoryService.js